module.exports = __webpack_public_path__ + "static/media/cdphp-app-demo.08fdcdb8.png";